// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    PRODUCTION: true,
    BASE_URL:'https://qaezlocatorapis.azurewebsites.net',
    CLIENT_ID: "web-ui",
    ADMIN_URL: "https://qaadmin.ezlocator.com",
    ACTIVE_TIME_DOMAIN: "ezlocator.com",
    CDN_URL: "https://v5-ezlocator-cdn-aqfhbnh4bza3gab3.z01.azurefd.net",
    // NEW_LAYOUT_CLIENT: 10488
    assetLinksUrl: 'https://qaezlocatorapis.azurewebsites.net/.well-known/assetlinks.json',
    appleAppSiteAssociationUrl: 'https://qaezlocatorapis.azurewebsites.net/.well-known/apple-app-site-association',
    CURRENT_DOMAIN_URL: "https://qa.ezlocator.com",
    NOINDEX: true
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  